import { apiConfig } from './config.api';
import { axiosWithHeaders } from '@innovyze/lib_get_service';

const notificationsApi = axiosWithHeaders({
  service: 'alertsScheduler',
  config: apiConfig,
  axiosCreateOpts: {
    timeout: 10000,
  },
});

export default notificationsApi;
